// extracted by mini-css-extract-plugin
export default {"tooltip":"GR-z","arrow":"HR-z"};